import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle",
  "use": "circle-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" id=\"circle\">\n  <circle cx=\"50%\" cy=\"50%\" r=\"50%\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol